import { useTheme } from '@mui/material';

import EditIcon from './svg/editIconMono.svg';

export interface IEditV2Props {
	size?: number;
}

export function EditIconV2({ size = 24 }: IEditV2Props) {
	const theme = useTheme();

	return (
		<EditIcon
			width={size}
			height={size}
			style={{ color: theme.palette.primary.main, display: 'block' }}
		/>
	);
}
